import React from 'react'
import { graphql } from "gatsby";
import { Helmet } from 'react-helmet';

import { Layout } from '@components/Layout.jsx';

import CollectionsPage from '@contents/parts/CollectionsPage.jsx'

const CollectionTemplate = ({ data }) => {
    
    const collection = data?.shopifyCollection;
    const title = collection?.title;
    const handle = collection?.handle;
    const products = collection?.products || [];
    const seoTitle = collection?.seo?.title || title + " | Blackbough Swim";
    const seoDescription = collection?.seo?.description || "";
    

    const desktopMatch = collection?.descriptionHtml?.match(/class="collection__desktop-banner".*?src="([^"]+)"/);
    const mobileMatch = collection?.descriptionHtml?.match(/class="collection__mobile-banner".*?src="([^"]+)"/);
    
    const collectionDescriptionJSON = collection?.metafields?.find(item => item.key === "collection_description");
    const collectionCdescription = collectionDescriptionJSON?.value !== undefined ? collectionDescriptionJSON?.value : [];
    
   

    const desktopBannerSrc = desktopMatch ? desktopMatch[1] : null;
    const mobileBannerSrc = mobileMatch ? mobileMatch[1] : null;

    console.log(collection)

    return (
        <Layout gaEvent={{eventName: 'page_view', params: {queryName: 'collections page'}}}>
            <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
            </Helmet>
			
            <CollectionsPage products={products} desktopBannerSrc={desktopBannerSrc} mobileBannerSrc={mobileBannerSrc} title={title} collectionCdescription={collectionCdescription} handle={handle} />
        </Layout>
	)
}
  
export const query = graphql`
  query($handle: String!) {
        shopifyCollection(
            sortOrder: {eq: MANUAL}
            handle: {eq: $handle}
            products: {elemMatch: {status: {eq: ACTIVE}}}
        ) {
        id
        title
        handle
        description
        descriptionHtml
        sortOrder
        products {
            id
            title
            handle
            collections {
                handle
            }
            media {
                preview {
                    image {
                        src
                        gatsbyImageData
                    }
                }
            }
            priceRangeV2 {
            minVariantPrice {
                amount
            }
            }
            tags
            variants {
                storefrontId
                compareAtPrice
            }
        }
        seo {
            title
            description
        }
        metafields {
            id
            key
            value
        }
        }
  }
`;

export default CollectionTemplate;